import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form, Table } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const getAuthToken = () => localStorage.getItem("authToken");


const Receipt = () => {
    const navigate = useNavigate();
    const [newReceipt, setNewReceipt] = useState({
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        date: new Date().toISOString().split('T')[0],
        description: ""
    });
    const [receipts, setReceipts] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);
    const [editingReceipt, setEditingReceipt] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchAccounts();
        fetchCashAccounts();
    }, []);



    const fetchAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-accounts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };


    const fetchCashAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9,10] }, // Sending an array correctly
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            if (response.data.data) {
                setCashAccounts(response.data.data); // Adjust based on actual API response structure
            } else {
                console.error("Failed to fetch cash accounts", response.data);
                alert("Failed to fetch cash accounts.");
            }
        } catch (error) {
            console.error("Error fetching accounts:", error);
            alert("An error occurred while fetching cash accounts.");
        }
    };
    
    

    const addReceipt = async () => {
        setLoading(true);
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}create-receipt`, newReceipt, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.data.status === "success") {
                alert(`Receipt added successfully! Receipt Number: ${response.data.receipt_number}`);
                setNewReceipt({ from_account_id: "", from_account: "", to_account_id: "", to_account: "", amount: "", date: newReceipt.date, description: "" });
    
            } else {
                alert(`Error: ${response.data.message}`);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An unexpected error occurred";
            alert(`Error adding receipt: ${errorMessage}`);
            console.error(error);
        }
        finally{
            setLoading(false);
        }
    };
    

    const deleteReceipt = async (id) => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            await axios.delete(`${appConstants.API_ROOT_URL}delete-receipt/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setReceipts(receipts.filter(receipt => receipt.id !== id));
        } catch (error) {
            alert("Error deleting receipt");
            console.error(error);
        }
    };

    const openEditModal = (receipt) => {
        setEditingReceipt(receipt);
        setShowModal(true);
    };

    const handleFromAccountSelection = (e) => {
        const selectedAccount = accounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setNewReceipt({
                ...newReceipt,
                from_account_id: selectedAccount.id,  // Store ID
                from_account: selectedAccount.name   // Store Name
            });
        } else {
            setNewReceipt({
                ...newReceipt,
                from_account_id: "",
                from_account: e.target.value // Allow typing
            });
        }
    };

    const handleToAccountSelection = (e) => {
        const selectedAccount = accounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setNewReceipt({
                ...newReceipt,
                to_account_id: selectedAccount.id,  // Store ID
                to_account: selectedAccount.name   // Store Name
            });
        } else {
            setNewReceipt({
                ...newReceipt,
                to_account_id: "",
                to_account: e.target.value // Allow typing
            });
        }
    };
    
    return (
        <Layout>
            <div className="p-3 bg-light">
                <h5>Create Receipt</h5>
                <Form>
                <Form.Group className="mb-2">
                        <Form.Label>Date</Form.Label>
                        <Form.Control type="date" value={newReceipt.date} 
                            onChange={(e) => setNewReceipt({ ...newReceipt, date: e.target.value })} />
                    </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>Received From</Form.Label>
                    <Form.Control 
                        list="accounts" 
                        value={newReceipt.from_account} // Show account name in input
                        onChange={(e) => handleFromAccountSelection(e)} 
                    />
                    <datalist id="accounts">
                        {accounts.map(account => (
                            <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                        ))}
                    </datalist>
                </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>To Account</Form.Label>
                        <Form.Control 
                            list="cash-accounts" 
                            value={newReceipt.to_account} // Show account name in input
                            onChange={(e) => handleToAccountSelection(e)} 
                        />
                        <datalist id="cash-accounts">
                        {cashAccounts.map(account => (
                            <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                        ))}
                    </datalist>
                    </Form.Group>



                    <Form.Group className="mb-2">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control type="number" value={newReceipt.amount} 
                            onChange={(e) => setNewReceipt({ ...newReceipt, amount: e.target.value })} />
                    </Form.Group>
                    
                    <Form.Group className="mb-2">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" value={newReceipt.description} 
                            onChange={(e) => setNewReceipt({ ...newReceipt, description: e.target.value })} />
                    </Form.Group>
                    <Button variant="primary" onClick={addReceipt} disabled={loading}>
                        <FaPlus /> Add Receipt
                    </Button>
                    <Button 
                        variant="secondary" 
                        className="ms-2" 
                        onClick={() => navigate("/receipt-list")}
                    >
                        View Receipts
                    </Button>
                </Form>
                
            </div>
        </Layout>
    );
};

export default Receipt;
